import React, { Component, Fragment } from "react";
import {taxSubheader, taxSubheaderItem} from './taxToBeLinkedStyle';

class TaxTaskSubHeader extends Component{
    render() {
        return (
            <div style={taxSubheader}>
                <span style={taxSubheaderItem}>
                    <a className="fs-14 color-wk-primary-blue font-weight: bold active bottom-border-color:blue">Tax Tasks to be linked</a>
                </span>
            </div>
        );
    }
}

export default TaxTaskSubHeader;